import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import { useCookies } from "react-cookie";
import axios from "axios";
import $ from "jquery";

export default function LibraryCreate() {

    let { id, bookid } = useParams();

    useEffect(() => {
        axios.post(`https://cloudify-backend.herokuapp.com/libraries/create/userid`, {
            "userId":id
        })
        .then(resp => {
            var data = resp.data;

            if(bookid) {
                if(data.sucesso == true) {
                    axios.post(`https://cloudify-backend.herokuapp.com/libraries/books/add/${data.libraryId}`, {
                        bookId: bookid
                    }).then(respp => {
                        window.location.href = `/libraries/${data.libraryId}/${bookid}`;
                    })
                }
            }

            else window.location.href = `/libraries/${data.libraryId}`;
        })
    }, [])

    return (
        <h2>Criando biblioteca...</h2>
    )
}